import { AdjustmentsReportPage } from "./AdjustmentsReportPage";

type Props = {};
const AdjustmentReport = (props: Props) => {
	return <AdjustmentsReportPage />;
};
export default AdjustmentReport;
